import React, { CSSProperties } from 'react';
import { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';

interface EmptyStateIconProps {
  type: EmptyStateIconType;
  style?: CSSProperties;
}

interface SvgProps {
  style?: CSSProperties;
}

const DumbbellSvg = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="8" y="12" width="8" height="24" rx="2" stroke="#AEB3B7" strokeWidth="2" />
      <rect
        x="40"
        y="36"
        width="8"
        height="24"
        rx="2"
        transform="rotate(-180 40 36)"
        stroke="#AEB3B7"
        strokeWidth="2"
      />
      <path
        d="M8 18H4C2.89543 18 2 18.8954 2 20V28C2 29.1046 2.89543 30 4 30H8"
        stroke="#AEB3B7"
        strokeWidth="2"
      />
      <path
        d="M40 30L44 30C45.1046 30 46 29.1046 46 28L46 20C46 18.8954 45.1046 18 44 18L40 18"
        stroke="#AEB3B7"
        strokeWidth="2"
      />
      <line x1="16" y1="24" x2="32" y2="24" stroke="#AEB3B7" strokeWidth="2" />
    </svg>
  );
};

const RoutineSvg = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.998 4h-1a3 3 0 00-3 3v11a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3h-1"
        stroke="#AEB3B7"
        strokeWidth="2"
      />
      <path
        d="M16.002 15h-8m8-4h-8"
        stroke="#AEB3B7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x={8.002} y={2} width={8} height={4} rx={0.5} stroke="#AEB3B7" strokeWidth="2" />
    </svg>
  );
};

const ChartSvg = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="5" y="24" width="10" height="18" rx="2" stroke="#AEB3B7" strokeWidth="2" />
      <rect x="19" y="14" width="10" height="28" rx="2" stroke="#AEB3B7" strokeWidth="2" />
      <rect x="33" y="6" width="10" height="36" rx="2" stroke="#AEB3B7" strokeWidth="2" />
    </svg>
  );
};

const HistorySvg = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.11596 27.1111C6.03934 26.418 6 25.7136 6 25C6 14.5066 14.5066 6 25 6C35.4934 6 44 14.5066 44 25C44 35.4934 35.4934 44 25 44C19.0313 44 13.7055 41.2478 10.2222 36.9433"
        stroke="#AEB3B7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 16V26H34"
        stroke="#AEB3B7"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 24L6.00119 28L2 24"
        stroke="#AEB3B7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmptyStateIcon = (props: EmptyStateIconProps) => {
  return (
    <ThemeProvider theme={themeState.current}>
      <EmptyStateIcons {...props} />
    </ThemeProvider>
  );
};

export type EmptyStateIconType = 'dumbbell' | 'routine' | 'bar-chart' | 'history';

const EmptyStateIcons = (props: EmptyStateIconProps) => {
  switch (props.type) {
    case 'dumbbell':
      return <DumbbellSvg style={{ width: 48, height: 48 }} />;
    case 'routine':
      return <RoutineSvg style={{ width: 48, height: 48 }} />;
    case 'bar-chart':
      return <ChartSvg style={{ width: 48, height: 48 }} />;
    case 'history':
      return <HistorySvg style={{ width: 48, height: 48 }} />;
  }
};
